import { WalletProvider } from "src/core/wallet/wallet.model";
import walletConnectIcon from "src/feature/auth/assets/images/wallet-connect-logo.png";
import walletConnectIconRound from "src/feature/auth/assets/images/wallet-connect-logo-round.svg";
import handcashIcon from "src/feature/auth/assets/images/handcash-logo.png";
import handcashIconRound from "src/feature/auth/assets/images/handcash-logo-round.png";

export const walletProviders = {
    [WalletProvider.WalletConnect]: { label: "WalletConnect", icon: walletConnectIcon, iconRound: walletConnectIconRound },
    [WalletProvider.HandCash]: { label: "HandCash", icon: handcashIcon, iconRound: handcashIconRound },
};